import { Controller } from '@hotwired/stimulus';
import consumer from "../channels/consumer";

export default class extends Controller {
  static values = { id: Number }

  connect() {
    const websiteId = this.idValue;
    if (websiteId) {
      this.channel = consumer.subscriptions.create(
        { channel: "WebsiteTurboChannel", website_id: websiteId },
        {
          received: this.handleReceived.bind(this),
          connected: () => {},
          disconnected: () => {}
        }
      );
    }
  }

  handleReceived(data) {
    if (data.message === 'finished') {
      // Use Turbo's soft navigation for smoother UX
      if (window.Turbo && typeof window.Turbo.visit === 'function') {
        window.Turbo.visit(window.location.href, { action: 'replace' });
      } else {
        window.location.reload();
      }
    }
  }

  disconnect() {
    if (this.channel) {
      this.channel.unsubscribe();
    }
  }
}
